module.exports = __webpack_public_path__ + "static/img/11.046ea73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/11.png
// module id = //ie
// module chunks = 0